import { IconSvg, IconSvgProps } from "./icon"

export default function Lock(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M8.31 10.782V8.146a3.69 3.69 0 1 1 7.38 0v2.636m-8.435 0h9.49s1.054 0 1.054 1.054v7.38s0 1.055-1.054 1.055h-9.49s-1.054 0-1.054-1.054v-7.38s0-1.055 1.054-1.055Zm3.163 4.745a1.582 1.582 0 1 0 3.164 0 1.582 1.582 0 0 0-3.164 0Z" />
    </IconSvg>
  )
}
